import Script from 'next/script';
import { useEffect, useState } from 'react';

import { Meta } from '@/layouts/Meta';
import { Main } from '@/templates/Main';

const UnidaysDiscount = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return () => {};
    const customElementNames: string[] = [];

    // Check if the custom elements are already defined
    if (window.customElements.get('unidays-access')) {
      customElementNames.push('unidays-access');
    }
    if (window.customElements.get('lottie-player')) {
      customElementNames.push('lottie-player');
    }
    if (customElementNames.length === 0) {
      setIsReady(true);
      return () => {};
    }
    // Hack to prevent unidays from defining the custom elements again
    // This is necessary because unidays script tries to redefine the custom elements
    // which causes an error in strict mode
    // We override the define method to skip already defined custom elements
    const defineCustomElement = CustomElementRegistry.prototype.define;
    customElements.define = function define(name, constructor, options) {
      if (customElementNames.includes(name)) {
        return;
      }
      defineCustomElement.call(this, name, constructor, options);
    };
    setIsReady(true);

    return () => {
      customElements.define = defineCustomElement;
    };
  }, []);

  return (
    <>
      {isReady && (
        <Script
          src="https://access.myunidays.com/unidays-partner-component.min.js"
          strategy="afterInteractive"
          crossOrigin="anonymous"
        />
      )}

      <Main
        meta={
          <Meta
            title={'Student Discount'}
            description={'My Muscle Chef Discount'}
            canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/unidays`}
            noIndexing={true}
          />
        }
      >
        <div className="h-[920px] w-full sm:h-[720px]">
          <unidays-access
            clientid={`${process.env.NEXT_PUBLIC_UNIDAYS_CLIENT_ID}`}
            redirecturi={`${process.env.NEXT_PUBLIC_UNIDAYS_REDIRECT_URL}`}
            locale="en-AU"
            mobileimage="https://www.datocms-assets.com/81001/1728882356-unidays-desktop.jpg"
            desktopimage="https://www.datocms-assets.com/81001/1728882356-unidays-desktop.jpg"
            imagealttext="My Muscle Chef Unidays Discount Banner"
            partnerid={`${process.env.NEXT_PUBLIC_UNIDAYS_PARTNER_ID}`}
          ></unidays-access>
        </div>
      </Main>
    </>
  );
};

export default UnidaysDiscount;
